/**
 * Multi-agent HTTP client — base URL and auth headers.
 */

import { getAuthToken } from "@/dataProvider/axios";
import env from "@/config/env";
import { resolveActiveOrgId, useAuthStoreV1 } from "@/stores/authStore_v1";

// Strip trailing slashes.
const cleanBaseUrl = (value: string): string => {
  let end = value.length;
  while (end > 0 && value[end - 1] === "/") end--;
  return value.slice(0, end);
};

/** e.g. https://ncoder-backend-prod-….run.app/api/proxy/multi-agent */
export const MULTI_AGENT_API_BASE_URL = cleanBaseUrl(
  `${cleanBaseUrl(env.API_URL)}/proxy/multi-agent`
);

export const multiAgentBaseUrl = MULTI_AGENT_API_BASE_URL;

// Tenant isolation: resolve the org from the ACTIVELY selected org only.
// No localStorage / cookie `org_id` / default-org fallback — a stale value
// would send another tenant's id in X-Organization-ID and leak data across
// users. (dev-agent reads selectedOrg?.id only.) The single-org case is safe
// because there is no other tenant to confuse it with.
//
// `resolveActiveOrgId` (`authStore_v1.ts`) is the shared, tested version of this rule — every
// multi-agent surface that resolves an org id calls it now, this one included.
export function getMultiAgentAuthHeaders(): Record<string, string> {
  const state = useAuthStoreV1.getState();
  const headers: Record<string, string> = {};
  const orgId = resolveActiveOrgId(state);
  if (orgId) {
    headers["X-Organization-ID"] = orgId;
  }
  if (state.user?.id) headers["X-User-ID"] = state.user.id;
  const token = getAuthToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
}
